module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand16-5d27ec510286b8f65a1ab6023c76579f.jpg";